import { SET_VIDEO } from "./../actions/videoActions";

const initState = { id: "", name: "", title: "" };

export const uiReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_VIDEO:
      return { ...action.payload };

    default:
      return state;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/videoReducer.js